module.exports = __webpack_public_path__ + "media/images/c-adminSidebarLink/withdrawal_requests-fe3fb17fae48f9ea87f8d16c6bb3bd76.svg";